module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Heavy.83a73e9.woff2";